export const ENDPOINT = {
    /* API MANAGER */

    GET_ALL_API_MANAGER: "mst/api",
    GET_SINGLE_API_MANAGER: "mst/api",

};
